<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "compUmatPerkawinan",
	props: ["triggerValidation"],
	data() {
		return {
			myOptions: {
				jenis: umatOpt.jenis,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatPerkawinanItem: (state) => state.umatPerkawinan.item,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>No Buku LM <span class="text-danger">*</span></label>
					<b-form-input
						name="no_buku_lm"
						v-model="umatPerkawinanItem.no_buku_lm"
						v-validate="{ required: true }"
						:state="validateState('no_buku_lm')"
						data-vv-as="No. Buku LM"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_buku_lm")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>No LM<span class="text-danger">*</span></label>
					<b-form-input
						name="no_lm"
						v-model="umatPerkawinanItem.no_lm"
						v-validate="{ required: true }"
						:state="validateState('no_lm')"
						data-vv-as="No. LM"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_lm")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Perkawinan</label>
					<b-form-input
						name="tgl_perkawinan"
						:state="validateState('tgl_perkawinan')"
						data-vv-as="Tanggal Perkawinan"
						v-validate="{ required: true }"
						v-model="umatPerkawinanItem.tgl_perkawinan"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_perkawinan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Imam Peneguh<span class="text-danger">*</span></label>
					<b-form-input
						name="imam_peneguh"
						v-model="umatPerkawinanItem.imam_peneguh"
						v-validate="{ required: true }"
						:state="validateState('pemberi_krisma')"
						data-vv-as="Imam Peneguh"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("imam_peneguh")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Keuskupan LM <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="keuskupan_lm"
						:class="validateStateCustom('keuskupan_lm')"
						data-vv-as="Keuskupan LM"
						v-validate="{ required: true }"
						v-model="umatPerkawinanItem.keuskupan_lm"
						:minMatchingChars="1"
						:data="myOptions.keuskupan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("keuskupan_lm")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Paroki LM<span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="paroki_lm"
						:class="validateStateCustom('paroki_lm')"
						data-vv-as="Paroki LM"
						v-validate="{ required: true }"
						v-model="umatPerkawinanItem.paroki_lm"
						:minMatchingChars="1"
						:data="myOptions.paroki"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("paroki_lm")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Nama Saksi I </label>

					<b-form-input
						name="wali"
						v-model="umatPerkawinanItem.wali"
						v-validate="{ required: false }"
						:state="validateState('wali')"
						data-vv-as="Wali Baptis 1"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("wali")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Nama Saksi II </label>

					<b-form-input
						name="wali2"
						v-model="umatPerkawinanItem.wali2"
						v-validate="{ required: false }"
						:state="validateState('wali2')"
						data-vv-as="Wali Baptis 2"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("wali2")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Gereja/Tempat</label>

					<b-form-input
						name="wali2"
						v-model="umatPerkawinanItem.gereja"
						v-validate="{ required: false }"
						:state="validateState('gereja')"
						data-vv-as="Gereja"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("gereja")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Jenis Perkawinan</label>
					<b-form-select
						name="jenis"
						:state="validateState('jenis')"
						data-vv-as="Jenis"
						v-validate="{ required: false }"
						v-model="umatPerkawinanItem.jenis"
						:options="myOptions.jenis"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("jenis")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Dispensasi atau Izin</label>

					<b-form-input
						name="izin"
						v-model="umatPerkawinanItem.izin"
						v-validate="{ required: false }"
						:state="validateState('izin')"
						data-vv-as="Dispensasi atau Izin"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("izin")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>No. Catatan Sipil</label>

					<b-form-input
						name="no_sipil"
						v-model="umatPerkawinanItem.no_sipil"
						v-validate="{ required: false }"
						:state="validateState('no_sipil')"
						data-vv-as="No. Catatan Sipil"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_sipil")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Catatan Sipil</label>
					<b-form-input
						name="tgl_sipil"
						:state="validateState('tgl_sipil')"
						data-vv-as="Tanggal Catatan Sipil"
						v-validate="{ required: false }"
						v-model="umatPerkawinanItem.tgl_sipil"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_sipil")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

